import { useState } from 'react';
import { FormField } from '@/kit/FormField';
import { Icon } from '@/kit/Icon';

/**
 * `<mat-form-field appearance="outline" class="search-field"><mat-icon>search</mat-icon><input matInput placeholder="Search">`
 * (the icon is projected into the infix, next to the input, exactly like the Angular markup).
 */
export function SearchField({ onSearch }: { onSearch: (text: string) => void }) {
  const [focused, setFocused] = useState(false);
  return (
    <FormField className="search-field" focused={focused}>
      <Icon name="search" />
      <input
        className="mat-mdc-input-element mdc-text-field__input mat-mdc-form-field-input-control"
        placeholder="Search"
        autoComplete="off"
        maxLength={100}
        onChange={(event) => onSearch(event.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
    </FormField>
  );
}
